import { create } from 'zustand'
import { persist } from 'zustand/middleware';

const storeSettings = (set) => ({
    username: '',
    setUserName: (_uname) => { set({ username: _uname }) },
    application: '',
    setApplication: (_app) => { set({ application: _app }) },
});

const useStoreUserRoles = create(persist(storeSettings, { name: 'archem-user', getStorage: () => sessionStorage, version: 0 }));

export default useStoreUserRoles;